<template>
	<div class="shape-style-editor style-editor-layout horizontal">
		<div class="dropdown-top">
			<div class="close-icon"></div>
		</div>
		<div class="dropdown-section">
			<div class="dropdown-section-title">Appears next to the button in dropdown</div>
			<TextField v-model="dropdownTextValue" placeholder="type to create dropdown alternate text" :readonly="readonly"></TextField>
		</div>
	</div>
</template>

<script>
import { DEFAULT_DROPDOWN } from '../../../dialogs/NewModuleDialog/ElementDataDefault.const';
import TextField from '../TextField.vue';

export default {
	name: 'DropdownTextStyleEditor',
	components: {
		TextField,
	},
	props: {
		btnSettings: { type: Object },
		readonly: { type: Boolean, default: false },
	},
	methods: {
		updateBtnSettings(payload) {
			this.$emit('update:btnSettings', payload);
		},
	},
	computed: {
		dropdownText: {
			set(value) {
				this.updateBtnSettings(Object.assign({ ...this.btnSettings }, { dropdownText: value }));
			},
			get() {
				return this.btnSettings.dropdownText || DEFAULT_DROPDOWN;
			},
		},
		dropdownTextValue: {
			set(value) {
				this.dropdownText = Object.assign({ ...this.dropdownText }, { value });
			},
			get() {
				return this.dropdownText.value;
			},
		},
	},
	data: () => ({
		maxRadius: 10,
		initialized: false,
	}),
};
</script>
<style scoped lang="scss">
.text-area-container {
	width: 250px;
}
</style>
